import Keycloak from 'keycloak-js'
import Hostapi from '@/core/utils/Hostapi'

const keycloak = new Keycloak({
    url: Hostapi.getUrlKeycloak(),
    realm: 'odonto-delta',
    clientId: 'odonto-delta-app'
})

export default keycloak